<table class="table table-sm table-borderless">
	<ng-container *ngFor="let data of list; let i=index">
		<thead>
			<tr>
				<th colSpan="3">
					<div class="h4 float-start" [ngClass]="{'mt-5':i!=0}">
						<br/>
						<div *ngIf="data.revisionType == 'Create'"> <nz-icon nzType="plus" nzTheme="outline" style="color: var(--success)"/> {{data.recordLabel}}</div>
						<div *ngIf="data.revisionType == 'Modify'"> <nz-icon nzType="edit" nzTheme="outline" style="color: var(--warning)"/> {{data.recordLabel}}</div>
						<div *ngIf="data.revisionType == 'Delete'"> <nz-icon nzType="delete" nzTheme="outline" style="color: var(--danger)"/> {{data.recordLabel}}</div>
					</div>
					<div class="float-end" [ngClass]="{'mt-5':i!=0}">
						<div class="h4 ">
							Agent: {{data.modifiedBy?.username??'UNKNOWN'}}
						</div>
						<div class="float-end">Time: {{data.date | date:'HH:mm:ss'}}</div>
					</div>
				</th>
			</tr>
			<tr class="table-dark">
				<th>Property Name</th>
				<th>Old Value</th>
				<th>New Value</th>
			</tr>
		</thead>
		<tbody class="mb-3 border">
			<ng-container>
				<tr class="border-top">
					<td>{{data.fields[0].fieldName}}</td>
					<td [ngClass]="{'bg-danger-subtle':data.fields[0].same == false}">
						<span [ngClass]="{'text-danger':data.fields[0].same == false}">
							<ng-container *ngTemplateOutlet="value; context: { fieldValue: data.fields[0].before, fieldType: data.fields[0].type }"></ng-container>
						</span>
					</td>
					<td [ngClass]="{'bg-success-subtle':data.fields[0].same == false}">
						<span [ngClass]="{'text-success':data.fields[0].same == false}">
							<ng-container *ngTemplateOutlet="value; context: { fieldValue: data.fields[0].after, fieldType: data.fields[0].type }"></ng-container>
						</span>
					</td>
				</tr>
				<ng-container *ngFor="let field of data.fields; let j = index">
					<tr *ngIf="j != 0" [ngClass]="{'striped-row':i % 2 == 0}">
						<td>
							{{field.fieldName}}
						</td>
						<td [ngClass]="{'bg-danger-subtle':field.same == false}">
							<span [ngClass]="{'text-danger':field.same == false}">
								<ng-container *ngTemplateOutlet="value; context: { fieldValue: field.before, fieldType: field.type }"></ng-container>
							</span>
						</td>
						<td [ngClass]="{'bg-success-subtle':field.same == false}">
							<span [ngClass]="{'text-success':field.same == false}">
								<ng-container *ngTemplateOutlet="value; context: { fieldValue: field.after, fieldType: field.type }"></ng-container>
							</span>
						</td>
					</tr>
				</ng-container>
			</ng-container>
		</tbody>
	</ng-container>
</table>
<ng-template #value let-fieldValue="fieldValue" let-fieldType="fieldType">
	<div [ngSwitch]="fieldType">
		<div *ngSwitchCase="'String'">{{fieldValue}}</div>
		<div *ngSwitchCase="'Number'">{{fieldValue | number}}</div>
		<div *ngSwitchCase="'Boolean'">{{fieldValue}}</div>
		<div *ngSwitchCase="'Date'">{{fieldValue|date: 'yyyy-MM-dd HH:mm:ss'}}</div>
	</div>
</ng-template>
